export * from "/app/nextjs/node_modules/@fortawesome/fontawesome-svg-core/index.mjs"